import { render, staticRenderFns } from "./FinishedRegistration.vue?vue&type=template&id=19ee7e5a&"
import script from "./FinishedRegistration.vue?vue&type=script&lang=js&"
export * from "./FinishedRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports